import type { FC } from 'react';
import styles from './DeliveryLeftPanel.module.css';
import type { DeliveryLeftPanelProps } from './DeliveryLeftPanel.types';

export const DeliveryLeftPanel: FC<DeliveryLeftPanelProps> = ({ children }) => {
  return <aside className={styles.panelLeft}>{children}</aside>;
};
